var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14.3269,
    r: 14,
    fill: "#F38D00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9997 7.68701C10.333 7.68701 7.33301 10.6803 7.33301 14.367C7.33301 17.7003 9.77301 20.467 12.9597 20.967V16.3003H11.2663V14.367H12.9597V12.8937C12.9597 11.2203 13.953 10.3003 15.4797 10.3003C16.2063 10.3003 16.9663 10.427 16.9663 10.427V12.0737H16.1263C15.2997 12.0737 15.0397 12.587 15.0397 13.1137V14.367H16.893L16.593 16.3003H15.0397V20.967C16.6106 20.7189 18.0411 19.9174 19.073 18.7071C20.1048 17.4967 20.6699 15.9574 20.6663 14.367C20.6663 10.6803 17.6663 7.68701 13.9997 7.68701Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFacebook);
export default __webpack_public_path__ + "static/media/logo_facebook.5dde8c67aa7bdeac4072b990710b8ffc.svg";
export { ForwardRef as ReactComponent };